export default "__VITE_ASSET__Dy9119xp__"